import { useEffect, useState } from "react";

import CheckedComponent from "components/CheckedComponent";
import PlanCardsList from "components/PlanCardsList";
import SubscriptionManagementCard from "components/SubscriptionManagementCard";
import TaggedText from "components/TaggedText";

import { useApiCalls } from "providers/ApiCallsProvider";


export default function BillingPageContent() {
  const [ cardInActionIdx, setCardInActionIdx ] = useState<number | undefined>(undefined);

  const { inProgress: apiCallInProgress } = useApiCalls();

  useEffect(() => {
    if (!apiCallInProgress) {
      setCardInActionIdx(undefined);
    }
  }, [ apiCallInProgress, setCardInActionIdx ]);


  return (
    <div className="flex flex-col gap-8 dark:gap-6 pb-8 dark:pb-6">
      <SubscriptionManagementCard setApiCallInProgress={() => setCardInActionIdx(-1)} />

      <PlanCardsList
        planInActionIdx={cardInActionIdx}
        setPlanInActionIdx={setCardInActionIdx}
      />

      <div className="flex justify-start lg:justify-center text-lg lg:text-base">
            <span className="text-left lg:text-center">
              Are you not sure what plan fits best for you? Or do you want to discuss the option of a custom plan?{" "}
              <TaggedText
                message="[Contact&nbsp;us.|contact_sales]"
                className="font-bold text-left lg:text-center"
              />
            </span>
      </div>
      <div className="flex flex-col gap-y-5">
        <div className="flex justify-start lg:justify-center text-lg lg:text-base lg:pt-5">All plans come with</div>

        {/* TODO: Update to use ALL_PLAN_FEATURES from constants/planFeatures.ts as single source of truth */}
        <div
          className="grid lg:grid-cols-[repeat(auto-fit,minmax(230px,max-content))] auto-rows-[1fr] justify-start lg:justify-around gap-6 text-sm whitespace-nowrap">
          <div className="flex-col">
            <CheckedComponent className="py-2">JS Rendering</CheckedComponent>
            <CheckedComponent className="py-2">Premium Proxies</CheckedComponent>
            <CheckedComponent className="py-2">JSON Auto Parsing</CheckedComponent>
          </div>
          <div className="flex-col">
            <CheckedComponent className="py-2">Rotating Proxy Pools</CheckedComponent>
            <CheckedComponent className="py-2">Custom Header Support</CheckedComponent>
            <CheckedComponent className="py-2">Unlimited Bandwidth</CheckedComponent>
          </div>
          <div className="flex-col">
            <CheckedComponent className="py-2">Automated Retries</CheckedComponent>
            <CheckedComponent className="py-2">Desktop & Mobile User Agents</CheckedComponent>
            <CheckedComponent className="py-2">99.9% Uptime Guarantee</CheckedComponent>
          </div>
          <div className="flex-col">
            <CheckedComponent className="py-2">Custom Session Support</CheckedComponent>
            <CheckedComponent className="py-2">CAPTCHA & Anti-Bot Detection</CheckedComponent>
            <CheckedComponent className="py-2">Professional Support</CheckedComponent>
          </div>
        </div>
      </div>
    </div>
  );
};
